export default __webpack_public_path__ + "static/0207-20276bc73a44a7bb6e9090f1e0a3a8d6.png";